import { render, staticRenderFns } from "./ImportacionPanelTernium.vue?vue&type=template&id=38fa8a62&"
import script from "./ImportacionPanelTernium.vue?vue&type=script&lang=js&"
export * from "./ImportacionPanelTernium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports